import React from 'react';

export default function Line({
  color,
  width,
  thic,
  margin,
}: {
  color?: string;
  width?: string;
  thic?: string;
  margin?: string;
}) {
  const aColor = color ? color : '#fff';
  const aWidth = width ? width : '250px';
  const aThic = thic ? thic : '2px';
  const aMargin = margin ? margin : '20px';

  return (
    <div
      style={{
        width: aWidth,
        height: aThic,
        backgroundColor: aColor,
        margin: 'auto',
        marginTop: aMargin,
        marginBottom: aMargin,
        textAlign: 'center',
      }}
    />
  );
}
